import { useMetadataStore } from '@/entities/metadata/model/metadataStore';
import { Folder, LayoutGrid, FileText, BarChart3, Table2 } from 'lucide-react';
import type { UserScreenNode } from '@/shared/types/system';

/** Sunucu ikonu (Icons ucu, base64 PNG) varsa onu, yoksa ekran tipine göre lucide ikonu. */
export function NavIcon({
  node,
  className = 'h-4 w-4',
}: {
  node: Pick<UserScreenNode, 'iconId' | 'screenTypeName' | 'children'>;
  className?: string;
}) {
  const icon = useMetadataStore((s) => (node.iconId ? s.icons.get(node.iconId) : undefined));
  if (icon)
    return <img src={`data:image/png;base64,${icon}`} alt="" className={`${className} object-contain`} />;
  const type = (node.screenTypeName ?? '').toLowerCase();
  if (node.children.length) return <Folder className={className} />;
  if (type === 'report') return <FileText className={className} />;
  if (type === 'dashboard') return <BarChart3 className={className} />;
  if (type === 'master' || type === 'masterdetail') return <Table2 className={className} />;
  return <LayoutGrid className={className} />;
}
